import React, { useEffect, useRef } from 'react';

/**
 * The candidate's self-view ("You") — a small picture-in-picture tile. Shows the live camera when
 * enabled, or a "Camera blocked" placeholder when the candidate turns it off. Bottom-left label
 * mirrors Google Meet, with a mic indicator that turns red when muted.
 */
const CamOffIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <path d="M16 16H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2m4 0h2a2 2 0 0 1 2 2v2m4-2l-4 3v2" />
    <path d="M3 3l18 18" />
  </svg>
);

const MicIcon = ({ muted }) => (
  <svg viewBox="0 0 24 24" width="12" height="12" fill="none"
    stroke={muted ? '#fb7185' : '#34d399'} strokeWidth="2" strokeLinecap="round">
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
    {muted && <path d="M3 3l18 18" stroke="#fb7185" />}
  </svg>
);

const CandidateTile = ({ stream, cameraOn, muted, className = '' }) => {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current && stream) videoRef.current.srcObject = stream;
  }, [stream]);

  return (
    <div className={`relative overflow-hidden rounded-2xl bg-slate-200 ring-1 ring-black/5 shadow-lg dark:bg-slate-800/80 dark:ring-white/10 ${className}`}>
      {/* mirror the self-view like every video app does */}
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        className={`h-full w-full object-cover [transform:scaleX(-1)] ${cameraOn ? '' : 'hidden'}`}
      />
      {!cameraOn && (
        <div className="flex h-full w-full flex-col items-center justify-center gap-1.5 text-slate-500 dark:text-slate-400">
          <span className="grid h-12 w-12 place-items-center rounded-full bg-black/5 dark:bg-white/5">
            <CamOffIcon />
          </span>
          <span className="text-xs">Camera blocked</span>
        </div>
      )}
      <span className="absolute bottom-2 left-2 flex items-center gap-1.5 rounded-md bg-black/55 px-2 py-1 text-xs font-medium text-white backdrop-blur">
        <MicIcon muted={muted} /> You
      </span>
    </div>
  );
};

export default CandidateTile;
